import React, { useContext, useState, useEffect } from "react"
import AppContext from "../../shared/AppContext"
import useDebounce from "../../hooks/useDebounce"
import FeedbackQuestionNavigator from "./FeedbackQuestionNavigator"
import { FaRegCheckCircle } from "react-icons/fa"
import { RiCloseLine } from "react-icons/ri"

const FeedbackModalContainer = (props) => {
  const {
    feedbackTypeId,
    feedbackType,
    children,
    createUpdateFeedback,
    setIsModalOpen,
  } = props
  const { trackEvent } = useContext(AppContext)

  const childrenArr = React.Children.toArray(children)
  const [currentIdx, setCurrentIdx] = useState(0)
  const [isFinished, setIsFinished] = useState(false)
  const [question, setQuestion] = useState("")

  const currentQuestionNum = currentIdx + 1
  const numOfQuestions = childrenArr.length
  const currentQuestion = childrenArr[currentIdx]

  const {
    setValue: setAnswers,
    value: answers,
    deferredValue: deferredAnswer,
  } = useDebounce(250, {})

  useEffect(() => {
    if (Object.keys(deferredAnswer).length) {
      trackEvent(`Answer Survey`, {
        question,
        answer: deferredAnswer[currentQuestionNum],
        "survey step": `${currentQuestionNum}/${numOfQuestions}`,
      })

      createUpdateFeedback({
        variables: {
          question,
          feedbackTypeId,
          feedbackType,
          answer: deferredAnswer[currentQuestionNum],
        },
      })
    }
  }, [deferredAnswer])

  const onClose = () => {
    setIsModalOpen(false)
    setIsFinished(false)
    setCurrentIdx(0)
    setAnswers({})

    trackEvent("Close Survey", {
      question: currentQuestion.props.question,
      answer: deferredAnswer[currentQuestionNum] || null,
      "survey step": `${currentQuestionNum}/${numOfQuestions}`,
    })
  }

  const DisplayQuestion = () => {
    return (
      <>
        <div
          data-cy="feedback-question-number"
          className="feedback-question-number"
        >
          Question {currentQuestionNum}/{numOfQuestions}
        </div>

        <div className="feedback-question-container">
          {React.cloneElement(currentQuestion, {
            setQuestion,
            currentAnswerValue: answers[currentQuestionNum],
            onChangeHandler: (answer) => {
              setAnswers({ ...answers, [currentQuestionNum]: answer })
            },
          })}
        </div>
        <FeedbackQuestionNavigator
          question={question}
          answer={deferredAnswer[currentQuestionNum]}
          currentIdx={currentIdx}
          numOfQuestions={numOfQuestions}
          setCurrentIdx={setCurrentIdx}
          setIsFinished={setIsFinished}
        />
      </>
    )
  }
  const DisplayConfirmation = () => {
    return (
      <>
        <div
          data-cy="feedback-confirmation-container"
          className="feedback-confirmation-container"
        >
          <h2>
            <FaRegCheckCircle />
            Thank you
          </h2>
          <div>We appreciate the time you took to share your feedback!</div>
        </div>
        <div className="modal-bottom-button-container">
          <button
            data-cy="confirm-finish-button"
            className="confirm-finish"
            onClick={() => {
              trackEvent("Continue Survey", {
                event: "close",
                surveyStep: `${currentQuestionNum}/${numOfQuestions}`,
              })

              onClose()
            }}
          >
            Close
          </button>
        </div>
      </>
    )
  }

  return (
    <>
      <section data-cy="feedback-modal" className="feedback-modal">
        <div className="flex">
          <button
            className="close"
            onClick={() => {
              trackEvent("End Survey", {
                question: currentQuestion.props.question,
                "survey step": `${currentQuestionNum}/${numOfQuestions}`,
              })
              onClose()
            }}
          >
            <RiCloseLine />
          </button>
        </div>
        <div>{isFinished ? DisplayConfirmation() : DisplayQuestion()}</div>
      </section>

      <div
        data-cy="feedback-modal-overlay"
        className="feedback-modal-overlay"
      ></div>
    </>
  )
}

export default FeedbackModalContainer
